import React, { useContext } from 'react'

import useContactDetails from '../hooks/useContactDetails'
import { LocaleContext, MeasurLocale } from '../locale/i18n'

import IconBriefcase from './icons/IconBriefcase'
import IconEmail from './icons/IconEmail'
import IconPhone from './icons/IconPhone'
import IconUser from './icons/IconUser'
import LabeledInput, { LabeledInputProps } from './LabeledInput'

interface Props {
  disabled?: boolean
  nameProps?: Partial<LabeledInputProps>
  emailProps?: Partial<LabeledInputProps>
  phoneProps?: Partial<LabeledInputProps>
  companyProps?: Partial<LabeledInputProps>
  companyFieldFirst?: boolean
}

const ContactDetailFields = ({
  disabled,
  nameProps,
  emailProps,
  phoneProps,
  companyProps,
  companyFieldFirst,
}: Props) => {
  const { locale, t } = useContext(LocaleContext)
  const { set, company, email, name, phone } = useContactDetails()

  const companyField = (
    <LabeledInput
      disabled={disabled}
      fieldId="company"
      icon={<IconBriefcase />}
      onChange={event => set({ company: event.currentTarget.value })}
      required
      label={t('contactForm.label.company')}
      sublabel={t('contactForm.label.companySublabel')}
      value={company}
      {...companyProps}
    />
  )

  return (
    <>
      {companyFieldFirst && companyField}
      <LabeledInput
        required
        disabled={disabled}
        fieldId="name"
        label={t('contactForm.label.name')}
        icon={<IconUser />}
        onChange={event => set({ name: event.currentTarget.value })}
        value={name}
        {...nameProps}
      />
      <LabeledInput
        disabled={disabled}
        fieldId="email"
        icon={<IconEmail />}
        onChange={event => set({ email: event.currentTarget.value })}
        required
        label={t('contactForm.label.email')}
        type="email"
        value={email}
        {...emailProps}
      />
      <LabeledInput
        disabled={disabled}
        fieldId="phone"
        icon={<IconPhone />}
        onChange={event => set({ phone: event.currentTarget.value })}
        placeholder={t('contactForm.placeholder.phone')}
        required
        label={t('contactForm.label.phone')}
        type="tel"
        value={phone}
        sublabel={t('contactForm.label.phoneSublabel')}
        warn={Boolean(
          locale !== MeasurLocale.FINLAND_FINNISH &&
            phone.trim().length > 2 &&
            !phone.trim().match(/(^\+|00|011)(\d|\s)+$/),
        )}
        {...phoneProps}
      />
      {!companyFieldFirst && companyField}
    </>
  )
}

export default ContactDetailFields
